import { OriginEntitySectionsOriginSectionEntityInterface } from '@types';
import { LangEnum } from '@enums';
import { translate } from './translate';
import _cloneDeep from 'lodash/cloneDeep';

export const buildNewcomerFormComponentsArray = (
  originSections: OriginEntitySectionsOriginSectionEntityInterface[],
  lang: LangEnum
) => {
  const baseComponentsSkeleton = [
    {
      key: 'newcomer',
      type: 'userAutocomplete',
      label: `<div style='font-size: 14px; font-family: IBMPlexSansMedium, Arial, serif; padding-bottom: 8px;'>${translate(
        'employee',
        lang
      )}</div>`,
      wrapperStyle: {
        position: '',
        marginBottom: '30px',
      },
      properties: {
        style: {
          width: '100%',
        },
      },
      inputProperties: {
        variant: 'outlined',
        size: 'small',
        placeholder: `${translate('template_input_name', lang)}`,
      },
      components: [],
      value: '',
    },
  ];

  const resultComponentsArray = _cloneDeep(baseComponentsSkeleton);
  for (const originSection of originSections) {
    for (const originBlock of originSection.originSection.originBlocks) {
      if (originBlock.originBlock.contactsType) {
        resultComponentsArray.push({
          key: `${originBlock.originBlock.contactsName}`,
          type: 'multipleFormGroup',
          label: `<div style='font-size: 18px; font-family: IBMPlexSansSemiBold, Arial, serif; margin-bottom: 16px; text-transform: uppercase; width: calc(100% - 62px);'>${
            originBlock.originBlock.title || originSection.originSection.name
          }</div>`,
          wrapperStyle: {
            position: 'relative',
            marginBottom: '35px',
          },
          inputProperties: {
            variant: '',
            size: '',
            placeholder: '',
          },
          properties: { style: { width: '' } },
          components: [
            {
              key: 'employee',
              type: 'userAutocomplete',
              label: `<div style='font-size: 14px; font-family: IBMPlexSansMedium, Arial, serif; margin-bottom: 8px;'>${translate(
                'employee',
                lang
              )}</div>`,
              properties: {
                style: {
                  width: '100%',
                },
              },
              inputProperties: {
                variant: 'outlined',
                size: 'small',
                placeholder: `${translate('template_input_name', lang)}`,
              },
              style: {
                marginBottom: '16px',
              },
              value: '',
            },
            {
              key: 'position',
              type: 'textfield',
              label: `<div style='font-size: 14px; font-family: IBMPlexSansMedium, Arial, serif; margin-bottom: 8px;'>${translate(
                'position',
                lang
              )}</div>`,
              style: {},
              value: '',
              prefilledValuePath: 'employee.rank.name',
              properties: {
                size: 'small',
                variant: 'outlined',
                placeholder: `${translate('position', lang)}`,
                style: {
                  width: '100%',
                },
              },
            },
          ],
          value: '',
        });
      }
    }
  }
  return resultComponentsArray;
};
